import { render, staticRenderFns } from "./holesponsors-list-table.vue?vue&type=template&id=7f361987&scoped=true"
import script from "./holesponsors-list-table.vue?vue&type=script&lang=js"
export * from "./holesponsors-list-table.vue?vue&type=script&lang=js"
import style0 from "./holesponsors-list-table.vue?vue&type=style&index=0&id=7f361987&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f361987",
  null
  
)

export default component.exports